import React from 'react'
import { Redirect } from 'react-router-dom'

const Dashboard: React.FC = () => {
  return <Redirect to='/aktenschrank' />
}

export default Dashboard
